import { Box, Grid, Paper, Typography } from "@mui/material";

const pick = (obj, ...keys) => {
  for (const k of keys) {
    if (obj?.[k] != null) return obj[k];
  }
  return null;
};

const FunnelStep = ({ label, value, prevValue }) => {
  const rate =
    prevValue > 0 ? `${Math.round((Number(value) / Number(prevValue)) * 100)}%` : "—";

  return (
    <Paper variant="outlined" sx={{ p: 1.5, textAlign: "center" }}>
      <Typography variant="caption" color="text.secondary" display="block">
        {label}
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 700 }}>
        {value ?? 0}
      </Typography>
      {prevValue != null ? (
        <Typography variant="caption" color="text.secondary">
          نسبت به مرحله قبل: {rate}
        </Typography>
      ) : null}
    </Paper>
  );
};

const LeadCampaignFunnelSection = ({ funnel }) => {
  if (!funnel) return null;

  const total = pick(funnel, "totalContacts", "TotalContacts") ?? 0;
  const registered = pick(funnel, "registered", "Registered") ?? 0;
  const requested = pick(funnel, "requested", "Requested") ?? 0;
  const contracted = pick(funnel, "contracted", "Contracted") ?? 0;
  const installed = pick(funnel, "installed", "Installed") ?? 0;

  const steps = [
    { label: "مخاطبین", value: total, prev: null },
    { label: "ثبت‌نام‌شده", value: registered, prev: total },
    { label: "درخواست پروژه", value: requested, prev: registered },
    { label: "قرارداد", value: contracted, prev: requested },
    { label: "نصب‌شده", value: installed, prev: contracted },
  ];

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="subtitle1" sx={{ mb: 1.5, fontWeight: 600 }}>
        قیف تبدیل لید
      </Typography>
      <Grid container spacing={1.5} alignItems="stretch">
        {steps.map((step, index) => (
          <Grid item xs={12} sm={6} md key={`funnel-${step.label}`}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              {index > 0 ? (
                <Typography variant="h6" color="text.secondary" sx={{ display: { xs: "none", md: "block" } }}>
                  ↓
                </Typography>
              ) : null}
              <Box sx={{ flex: 1 }}>
                <FunnelStep label={step.label} value={step.value} prevValue={step.prev} />
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

const RankList = ({ title, items, rateKey = "requestRate" }) => {
  const list = Array.isArray(items) ? items : [];
  if (list.length === 0) return null;

  return (
    <Paper variant="outlined" sx={{ p: 2, height: "100%" }}>
      <Typography variant="subtitle2" sx={{ mb: 1.5, fontWeight: 600 }}>
        {title}
      </Typography>
      {list.map((row) => {
        const id = pick(row, "id", "Id");
        const name = pick(row, "title", "Title") || `#${id}`;
        const contacts = pick(row, "contactCount", "ContactCount") ?? 0;
        const rate = pick(row, rateKey, "RequestRate", "requestRate") ?? 0;
        return (
          <Box
            key={`${title}-${id}`}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: 1,
              py: 0.75,
              borderBottom: "1px solid",
              borderColor: "divider",
            }}
          >
            <Typography variant="body2">{name}</Typography>
            <Typography variant="body2" color="text.secondary">
              {contacts} مخاطب · {rate}%
            </Typography>
          </Box>
        );
      })}
    </Paper>
  );
};

export { LeadCampaignFunnelSection, RankList, pick };
